import './Loader.css'

var Loader = {
    initialize () {
        this.loader = document.querySelector('.Loader')
        this._deactivateBinded = this._deactivate.bind(this)

        this.activate(true)
    },

    activate (init) {
        this.promise = new Promise(
            (resolve) => {
                this.loader.style.display = 'block'
                this.loader.classList.add('isActive')
                this.loader.classList.add('isMoved')

                if (init) {
                    setTimeout(() => {
                        resolve()
                    }, 500)
                } else {
                    resolve()
                }
            }
        )

        return this.promise
    },

    deactivate() {
        return new Promise(
            (resolve, reject) => {
                this.resolve = resolve
                this.reject = reject

                if (jQuery(this.loader).hasClass('Loader--projectItem')) {
                    this._deactivateProjectItem()
                } else {
                    // setTimout - что бы Loader спокойно закрылся и анимация закрытия не тормозила
                    setTimeout(() => {
                        this.loader.addEventListener('transitionend', this._deactivateBinded)
                        this.loader.addEventListener('webkitTransitionEnd', this._deactivateBinded)
                        this.loader.classList.remove('isMoved')

                        // на случай если пользователь сменить вкладку в браузере
                        // тогда transitionend может не вызваться
                        this.transitionTimeout = setTimeout(() => {
                            this._deactivateBinded()
                        }, 1000)
                    }, 250)
                }
            }
        )
    },

    _deactivate() {
        window.clearTimeout(this.transitionTimeout);
        this.loader.removeEventListener('transitionend', this._deactivateBinded)
        this.loader.removeEventListener('webkitTransitionEnd', this._deactivateBinded)

        this.loader.classList.remove('isActive')
        this.loader.style.display = 'none'

        this.resolve()

        this.promise = null
        this.resolve = null
        this.reject = null
    },

    _deactivateProjectItem() {
        let $item = jQuery(this.loader).find('.ProjectItem')
        let $text = $item.find('.ProjectItem-text')

        $text.css('-webkit-animation-play-state', 'paused')
        $text.css('animation-play-state', 'paused')

        let opacity = getComputedStyle($text[0]).opacity

        jQuery.Velocity.hook($text[0], 'opacity', opacity)

        $text.css('-webkit-animation-name', 'none')
        $text.css('animation-name', 'none')

        jQuery.Velocity.animate($text[0], {opacity: 0})

        jQuery.Velocity.animate($item[0], {scale: 4}, {duration: 2000})
    }
}

export default Loader


// WEBPACK FOOTER //
// ./assets/app/front/components/Loader/Loader.js